import { useMemo } from 'react';
import { useRouter } from 'next/router';
import { Container } from 'theme-ui';
import { useTranslation } from 'next-i18next';
import { TCategoriesTree, TParsedImageWithType } from '@features/categories/typescript';
import Breadcrumbs from '@components/Breadcrumbs/Breadcrumbs';
import styles from '@features/categories/components/CategoriesHead/CategoriesHead.styles';
import { IBreadcrumbStep } from '@typescript/index';
import Heading from '@components/Heading/Heading';
import theme from '@styles/theme';
import ImageSource from '@components/ImageSource/ImageSource';
import { createBreacrumbs } from '@utils/breadcrumbs';
type PropsType = {
  img: TParsedImageWithType;
  title: string;
  categoriesTree: TCategoriesTree;
  categoryId: number;
};
const CategoriesHead = ({
  img,
  title,
  categoriesTree,
  categoryId
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const router = useRouter();
  const {
    mainCategory
  } = router.query;
  const breadcrumbSteps: IBreadcrumbStep[] = useMemo(() => {
    const steps = createBreacrumbs(t('home'), categoriesTree, categoryId, mainCategory, router.pathname);
    return steps.length > 0 ? steps : [{
      name: t('home'),
      href: {
        pathname: '/',
        query: {}
      },
      id: 0
    }];
  }, [categoryId, categoriesTree, mainCategory, router.pathname, t]);
  return <Container variant="fluid" sx={styles.mainContainer}>
      <div sx={styles.imgContainer} data-cy="CategoriesHeadImage">
        <ImageSource sizes="100vw" imageSources={img} priority alt={title} />
      </div>
      <Breadcrumbs steps={breadcrumbSteps} />
      <div sx={styles.header} data-cy="CategoriesHeadTitle">
        <Heading size={theme.fontSizes.h1} h={1} display={3} mobile pb={16} align="center">
          {title}
        </Heading>
      </div>
    </Container>;
};
export default CategoriesHead;